import { render, staticRenderFns } from "./DashboardPropertyRequests.vue?vue&type=template&id=419c44a0&"
import script from "./DashboardPropertyRequests.vue?vue&type=script&lang=js&"
export * from "./DashboardPropertyRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports